module.exports = __webpack_public_path__ + "img/category-casino.0b2b3e80.png";